import * as React from 'react';
import { motion, useInView } from 'framer-motion';

const AboutHero: React.FC = () => {
  const ref = React.useRef(null);
  const isInView = useInView(ref, { once: true });
  
  const titleRef = React.useRef(null);
  const titleInView = useInView(titleRef, { once: true });


  return (
    <motion.section 
      ref={ref}
      className="relative pt-24 px-4"
      initial={{ opacity: 0 }}
      animate={isInView ? { opacity: 1 } : { opacity: 0 }}
      transition={{ duration: 1, delay: 0.2 }}
    >
      <div className="container mx-auto max-w-4xl text-center">
        <motion.h2 
          ref={titleRef}
          className="text-3xl lg:text-4xl text-dark text-center"
          initial={{ opacity: 0, y: 60 }}
          animate={titleInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 60 }}
          transition={{ duration: 0.5, delay: 0.5 }}
        >
          Sobre nós
        </motion.h2>
      </div>
    </motion.section>
  );
};

export default AboutHero; 